
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoaundhanathcabservice() {



    const cardData =
    {
        keyword: 'Pune to Aundha Nagnath Cab Service',
        heading: 'S9 Travels: Pune to Aundha Nagnath Cab Service',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services for your journey from Pune to Aundha Nagnath, a prominent religious site located in the state of Haryana. Aundha Nagnath is known for the Aundha Nagnath Temple, dedicated to Lord Shiva, and is considered a sacred pilgrimage for devotees. Whether you are visiting for spiritual reasons or exploring the local culture, we ensure a smooth and comfortable journey. Aundha Nagnath is approximately 1,200 km from Pune, with a travel time of around 20-22 hours by road. With our well-maintained fleet and professional drivers, you can enjoy a safe, hassle-free, and memorable trip.',

        top: 'Top Places to Visit in Aundha Nagnath with S9 Travels',

"topPlaces": [
    {
      "title": "Aundha Nagnath Temple",
      "description": "The Aundha Nagnath Temple is the main attraction in the town, dedicated to Lord Shiva. The temple holds great religious significance and is an important pilgrimage site for devotees of Lord Shiva. The temple's intricate architecture and serene ambiance make it a peaceful place for spiritual reflection and prayer."
    },
    {
      "title": "Nagnath Fort",
      "description": "The Nagnath Fort is located near the Aundha Nagnath Temple and is historically significant. The fort offers a great opportunity to explore the local history and provides beautiful views of the surrounding landscape. Visitors can hike to the fort and enjoy the peaceful surroundings."
    },
    {
      "title": "Rishabdev Temple",
      "description": "The Rishabdev Temple is another important religious site located near Aundha Nagnath. The temple is dedicated to Rishabdev, the first Tirthankara of Jainism, and attracts Jain devotees. The serene atmosphere of the temple adds to the spiritual experience."
    },
    {
      "title": "Sarai of Aundha",
      "description": "The Sarai of Aundha is an ancient rest house that has historical significance. The building is a well-preserved example of the region's architectural heritage. It is a peaceful place to relax and take in the historical surroundings."
    },
    {
      "title": "Brahma Sarovar",
      "description": "The Brahma Sarovar is a large sacred pond near the Aundha Nagnath Temple. It is considered an important site for religious rituals and is often visited by pilgrims for holy baths. The area around the sarovar is tranquil and ideal for a peaceful retreat."
    },
    {
      "title": "Kachwaha Fort",
      "description": "The Kachwaha Fort is a historical fort located near Aundha. The fort provides panoramic views of the surrounding area and is a great spot for those interested in exploring the history and architecture of the region. The fort is a bit off the beaten path, making it a quiet place for visitors."
    },
    {
      "title": "Rishabhdeo Park",
      "description": "The Rishabhdeo Park is a well-maintained park located near the temple complex. It is an excellent spot for a leisurely stroll or to enjoy the surroundings while taking a break from the religious sites. The park is often visited by families and nature lovers."
    },
    {
      "title": "Guru Gorakhnath Temple",
      "description": "The Guru Gorakhnath Temple is dedicated to Guru Gorakhnath, one of the prominent Nath yogis. The temple is known for its peaceful surroundings and spiritual significance. It attracts devotees seeking blessings and spiritual guidance."
    },
    {
      "title": "Aundha Nagnath Bazaar",
      "description": "The Aundha Nagnath Bazaar is a traditional market in the town where visitors can shop for local handicrafts, religious items, and souvenirs. The market is an excellent place to immerse yourself in the local culture and experience the daily life of the town."
    }
],

"services": [
    {
      "name": "Book Pune to Aundha Nagnath Taxi",
      "description": "If you're planning to visit the Aundha Nagnath Temple from Pune, S9 Travels offers reliable and comfortable taxi services. Book your Pune to Aundha Nagnath taxi for a smooth and hassle-free journey. Our well-maintained vehicles and experienced drivers ensure a safe and enjoyable trip to this sacred destination."
    },
    {
      "name": "Book Pune to Aundha Nagnath Cab Booking",
      "description": "For your trip from Pune to Aundha Nagnath, S9 Travels provides easy online cab booking services. Whether you're traveling solo, with family, or in a group, we have the perfect vehicle to accommodate your needs. Book your Aundha Nagnath cab with us and experience a comfortable and convenient journey."
    },
    {
      "name": "Book Pune to Aundha Nagnath Taxi Service",
      "description": "S9 Travels offers comprehensive taxi services for your journey from Pune to Aundha Nagnath. Choose from our fleet of cars and let us handle the logistics so you can focus on your pilgrimage or trip. Our services include timely pickups, experienced drivers, and clean vehicles, ensuring you a pleasant travel experience."
    },
    {
      "name": "Book Pune to Aundha Nagnath One-Way Taxi",
      "description": "If you're looking for a one-way taxi from Pune to Aundha Nagnath, S9 Travels has got you covered. We provide one-way taxi services that are economical and convenient, perfect for those traveling to Aundha Nagnath without needing a return journey. Book your one-way taxi today and enjoy a smooth, one-way trip."
    },
    {
      "name": "Book Pune to Aundha Nagnath Round Trip",
      "description": "For a more flexible option, S9 Travels offers round trip taxi services from Pune to Aundha Nagnath. Our round trip services allow you to travel to Aundha Nagnath and return to Pune with ease and comfort. We ensure a hassle-free journey, tailored to your schedule."
    },
    {
      "name": "Book Pune to Aundha Nagnath Cab Fare",
      "description": "At S9 Travels, we offer competitive and transparent pricing for your journey from Pune to Aundha Nagnath. Our cab fare is based on the vehicle type, trip duration, and distance, with no hidden charges. Reach out to us for an affordable and detailed fare estimate for your Aundha Nagnath trip."
    },
    {
      "name": "Book Pune to Aundha Nagnath Car Rental",
      "description": "For travelers looking for flexibility, S9 Travels offers car rental services from Pune to Aundha Nagnath. Whether you're looking to explore the route at your own pace or need a comfortable car for the trip, we have a range of vehicles to choose from. Rent a car today and enjoy the freedom to travel on your schedule."
    },
    {
      "name": "Book Pune to Aundha Nagnath Luxury Taxi",
      "description": "If you're looking for a more premium experience, S9 Travels offers luxury taxi services to Aundha Nagnath. Our luxury taxis provide a comfortable and stylish ride, equipped with the latest amenities to ensure that your journey is not just pleasant but also luxurious."
    },
    {
      "name": "Affordable Aundha Nagnath Cab from Pune",
      "description": "At S9 Travels, we offer affordable taxi services for your trip to Aundha Nagnath. Enjoy the convenience of a comfortable ride at competitive rates, making your journey cost-effective without compromising on quality. Book your affordable Aundha Nagnath cab now for a seamless travel experience."
    },
    {
      "name": "Private Aundha Nagnath Taxi from Pune",
      "description": "For those who prefer a more private and personalized travel experience, S9 Travels provides private taxi services from Pune to Aundha Nagnath. Enjoy the luxury of privacy, comfort, and flexibility with our private taxi service, ensuring your journey is relaxing and tailored to your preferences."
    },
    {
      "name": "Aundha Nagnath Temple Taxi",
      "description": "Visit the famous Aundha Nagnath Temple with S9 Travels' temple taxi service. Our drivers are familiar with the best routes and will ensure you arrive at the temple promptly and safely. Whether you're planning a spiritual pilgrimage or a cultural trip, our taxi services to Aundha Nagnath Temple are tailored to meet your needs."
    },
    {
      "name": "Aundha Nagnath Trip from Pune",
      "description": "Planning a trip from Pune to Aundha Nagnath? S9 Travels offers seamless taxi services for your Aundha Nagnath trip. With professional drivers and comfortable vehicles, we make sure your journey is enjoyable and hassle-free. Enjoy the scenic drive and explore the temple and its surroundings at your leisure."
    },
    {
      "name": "Book Aundha Nagnath Yatra Taxi",
      "description": "For those undertaking the Aundha Nagnath Yatra, S9 Travels provides specialized yatra taxi services. Our taxis are comfortable, spacious, and equipped with everything you need to make your yatra experience peaceful and enjoyable. We ensure that your pilgrimage journey is smooth, with timely pickups and expert drivers who know the route well."
    },
    {
      "name": "Pune to Aundha Nagnath Temple Tour",
      "description": "Embark on a spiritual tour to Aundha Nagnath Temple with S9 Travels. We offer temple tour cab services to help you explore the holy site and its surroundings. Our taxis are equipped to provide a comfortable ride while you focus on your prayers and exploration of the temple."
    },
    {
      "name": "Group Booking for Aundha Nagnath",
      "description": "For groups traveling together to Aundha Nagnath, S9 Travels offers group bookings. Whether you're traveling with friends, family, or a religious group, we provide spacious and affordable taxis that can accommodate large groups comfortably. Book your group taxi from Pune to Aundha Nagnath for an enjoyable and coordinated trip."
    }
],

"tableData": [
  ["Book Pune To Aundha Nagnath Taxi", "Book Pune To Aundha Nagnath Cab Booking"],
  ["Book Pune To Aundha Nagnath Taxi Service", "Book Pune To Aundha Nagnath One-Way Taxi"],
  ["Book Pune To Aundha Nagnath Round Trip", "Book Pune To Aundha Nagnath Cab Fare"],
  ["Book Pune To Aundha Nagnath Car Rental", "Book Pune To Aundha Nagnath Luxury Taxi"],
  ["Affordable Aundha Nagnath Cab from Pune", "Private Aundha Nagnath Taxi from Pune"],
  ["Aundha Nagnath Temple Taxi", "Aundha Nagnath Trip from Pune"],
  ["Book Aundha Nagnath Yatra Taxi", "Pune to Aundha Nagnath Temple Tour"],
  ["Group Booking for Aundha Nagnath", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the significance of timely travel, especially when visiting the sacred Aundha Nagnath Temple. Our drivers ensure prompt pickups and drop-offs, so you can reach your destination on time and enjoy a peaceful and spiritual experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a wide range of well-maintained vehicles, including sedans, SUVs, and premium cars, to ensure your journey from Pune to Aundha Nagnath is as comfortable as possible. With spacious interiors, air conditioning, and cushioned seating, our vehicles are perfect for long-distance travel."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes to Aundha Nagnath. They ensure a smooth, safe, and stress-free journey, allowing you to relax and focus on your trip rather than the road."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable, competitive pricing for your Pune to Aundha Nagnath trip. There are no hidden fees, and we provide a clear breakdown of costs, so you can plan your budget without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a safe and secure journey throughout your trip."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning journey or a late-night return, S9 Travels is available 24/7. Our customer service team is always available to help with your booking or any other inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Aundha Nagnath journey is simple and convenient. You can book through our website, mobile app, or contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Aundha Nagnath for religious purposes or leisure, we offer customized travel packages to suit your preferences. Let us know your requirements, and we’ll ensure a unique and memorable trip."
  }
]




















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Aundha Nagnath cab with S9 Travels?',
            answer: 'Booking a cab is easy! You can book online through our website or app, or you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Aundha Nagnath trip?',
            answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed for comfort, making your long-distance trip to Aundha Nagnath comfortable and enjoyable.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Aundha Nagnath?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Aundha Nagnath. They ensure a smooth and safe journey, allowing you to relax during the trip.',
          },
          {
            question: 'How do I pay for my Pune to Aundha Nagnath cab rental?',
            answer: 'We offer multiple payment options including cash, credit/debit cards, and online payment via our app for your convenience.',
          },
          {
            question: 'Can I book a round trip from Pune to Aundha Nagnath?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and timely return journey from Aundha Nagnath.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you in advance, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Aundha Nagnath?',
            answer: 'Yes, we offer sightseeing services around Aundha Nagnath. Explore the famous temple and nearby attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Aundha Nagnath cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we’ll make necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Aundha Nagnath?',
            answer: 'Yes, we offer corporate and group travel services to Aundha Nagnath. Whether it’s for a religious group trip or corporate outing, we ensure a smooth and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Aundha Nagnath journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Aundha Nagnath.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vishal Jadhav',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my visit to Aundha Nagnath. The driver was prompt, and the vehicle was clean and comfortable. It was a smooth ride, and I felt very safe. Highly recommend S9 Travels!”',
        },
        {
          name: 'Mrs. Aarti Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip to Aundha Nagnath was smooth and enjoyable, thanks to S9 Travels. The vehicle was spacious and clean, and the driver was polite and professional. We’ll definitely book again for our next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Aundha Nagnath Cab Service",
        "description": "Book Pune to Aundha Nagnath taxi services with S9 Travels for a comfortable and affordable journey. We offer one-way and round-trip taxi options, luxury car rentals, and private taxis for your Aundha Nagnath temple visit. Choose from group bookings, private or Efficient Taxis, and enjoy a seamless Aundha Nagnath yatra tour.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Aundha Nagnath Cab Service | Affordable Taxi & Temple Tour | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Aundha Nagnath taxi services for one-way and round-trip rides. Enjoy private or Efficient Taxis, luxury car rentals, and affordable cab bookings for your Aundha Nagnath temple visit. Group bookings available for Aundha Nagnath yatra tours and trips." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoaundhanathcabservice;